export const iconFontAwesomeBuildingsShop = (
	<i className="fa-solid fa-shop"></i>
);
